(function () {
  'use strict';

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function openDrawer() {
    var drawer = qs('#CartDrawer');
    if (drawer) drawer.classList.add('is-open');
    document.body.classList.add('cart-drawer-open');
  }

  function closeDrawer() {
    var drawer = qs('#CartDrawer');
    if (drawer) drawer.classList.remove('is-open');
    document.body.classList.remove('cart-drawer-open');
  }

  function money(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var noDecimals = format.indexOf('amount_no_decimals') !== -1;
    var value = noDecimals
      ? Math.round(cents / 100).toString()
      : (cents / 100).toFixed(2);
    return format.replace(/\{\{\s*amount(_no_decimals)?(_with_comma_separator)?\s*\}\}/, value);
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function renderCart(cart) {
    qsa('.cart-count').forEach(function (el) { el.textContent = cart.item_count; });

    var itemsEl = qs('#CartDrawerItems');
    var subtotalEl = qs('#CartDrawerSubtotal');
    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>';
    } else {
      itemsEl.innerHTML = cart.items.map(function (item, idx) {
        var line = idx + 1;
        var variantLabel = (item.variant_title && item.variant_title !== 'Default Title')
          ? '<div class="cart-drawer__item-variant">' + item.variant_title + '</div>' : '';
        var img = item.image ? '<img src="' + item.image + '&width=160" alt="">' : '<div class="cart-drawer__item-placeholder"></div>';

        return (
          '<div class="cart-drawer__item">' +
            img +
            '<div class="cart-drawer__item-info">' +
              '<a href="' + item.url + '">' + item.product_title + '</a>' +
              variantLabel +
              '<div class="cart-drawer__item-row">' +
                '<div class="qty-stepper qty-stepper--sm">' +
                  '<button type="button" class="cart-qty-decrease" data-line="' + line + '">&minus;</button>' +
                  '<input type="number" class="cart-qty-input" data-line="' + line + '" value="' + item.quantity + '" min="0">' +
                  '<button type="button" class="cart-qty-increase" data-line="' + line + '">&plus;</button>' +
                '</div>' +
                '<span class="cart-drawer__item-price">' + money(item.final_line_price) + '</span>' +
              '</div>' +
            '</div>' +
            '<button type="button" class="cart-drawer__remove" data-line="' + line + '" aria-label="Remove item">&times;</button>' +
          '</div>'
        );
      }).join('');
    }

    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);

    qsa('.cart-qty-decrease', itemsEl).forEach(function (btn) {
      btn.addEventListener('click', function () { changeLine(this.dataset.line, -1); });
    });
    qsa('.cart-qty-increase', itemsEl).forEach(function (btn) {
      btn.addEventListener('click', function () { changeLine(this.dataset.line, 1); });
    });
    qsa('.cart-qty-input', itemsEl).forEach(function (input) {
      input.addEventListener('change', function () { setLineQty(this.dataset.line, parseInt(this.value || '0', 10)); });
    });
    qsa('.cart-drawer__remove', itemsEl).forEach(function (btn) {
      btn.addEventListener('click', function () { setLineQty(this.dataset.line, 0); });
    });
  }

  function changeLine(line, delta) {
    var input = qs('.cart-qty-input[data-line="' + line + '"]');
    var newQty = Math.max(0, parseInt((input && input.value) || '0', 10) + delta);
    setLineQty(line, newQty);
  }

  function setLineQty(line, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function (err) { console.error('Cart update failed:', err); });
  }

  function interceptAddToCartForms() {
    qsa('form[action*="/cart/add"]').forEach(function (form) {
      if (form.dataset.drawerBound) return;
      form.dataset.drawerBound = 'true';

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var submitBtn = form.querySelector('button[type="submit"]');
        var originalText = submitBtn ? submitBtn.textContent : '';
        if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Adding…'; }

        fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
          .then(function (r) { return r.json(); })
          .then(function (result) {
            if (result.status) {
              // Shopify returns an error object with a `status` key on failure (e.g. sold out)
              throw new Error(result.description || 'Could not add to cart');
            }
            return fetchCart();
          })
          .then(function (cart) {
            renderCart(cart);
            openDrawer();
          })
          .catch(function (err) {
            console.error('Add to cart failed:', err);
            alert(err.message || 'Sorry, that item could not be added to your cart.');
          })
          .finally(function () {
            if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = originalText; }
          });
      });
    });
  }

  function interceptCartIconLinks() {
    var headerCartIcon = qs('#HeaderCartIcon');
    if (!headerCartIcon || headerCartIcon.dataset.drawerBound) return;
    headerCartIcon.dataset.drawerBound = 'true';

    headerCartIcon.addEventListener('click', function (e) {
      e.preventDefault();
      fetchCart().then(function (cart) {
        renderCart(cart);
        openDrawer();
      });
    });
  }

  function init() {
    interceptAddToCartForms();
    interceptCartIconLinks();

    var closeBtn = qs('#CartDrawerClose');
    var overlay = qs('#CartDrawerOverlay');
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
